var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { MedicationType } from '../../Contracts/MedicationModels';
import { SwitchMedicationInfoBar } from './SwitchMedicationInfoBar';
import { DecisionSupportBanner } from './DecisionSupportBanner/DecisionSupportBanner';
import { FreeTextMedicationWarningBar } from './FreeTextMedicationWarningBar';
import { LmbcWarningBar } from './LmbcWarningBar';
import styles from './MedicationAlertBanner.module.css';
import { LemiInfoBar } from './LemiInfoBar';
import { ComplementaryTherapyOrderInfoBar } from './ComplementaryTherapyOrderInfoBar';
import { ScopeOfPracticeBanner } from './ScopeOfPracticeBanner';
var GeneralBanner = function (props) {
    var _a;
    if (props.patientMedication.isFreeTextMedication) {
        if (props.patientMedication.medicationType === MedicationType.ComplementaryTherapyOrder) {
            return React.createElement(ComplementaryTherapyOrderInfoBar, null);
        }
        else {
            return React.createElement(FreeTextMedicationWarningBar, null);
        }
    }
    if (((_a = props.patientMedication) === null || _a === void 0 ? void 0 : _a.medication) === null || props.patientMedication.medication === undefined) {
        return null;
    }
    if (props.patientMedication.medication.isOnLemi) {
        return React.createElement(LemiInfoBar, null);
    }
    if (props.patientMedication.medication.isOnLmbc && !props.patientMedication.medication.isTradeProductPack) {
        return (React.createElement(LmbcWarningBar, null));
    }
    if (props.patientMedication.originalMedication !== null &&
        props.patientMedication.originalMedication.code !== props.patientMedication.medication.code) {
        return React.createElement(SwitchMedicationInfoBar, { tradeProductName: props.patientMedication.originalMedication.name });
    }
    return null;
};
export function MedicationAlertBanner(props) {
    return (React.createElement("div", { className: styles.container },
        React.createElement(DecisionSupportBanner, { patient: props.patient, patientMedication: props.patientMedication, decisionSupportDetail: props.decisionSupportDetail, onNavigateToMedication: props.onNavigateToMedication }),
        props.showVerbalOrder && React.createElement(ScopeOfPracticeBanner, null),
        React.createElement(GeneralBanner, __assign({}, props))));
}
